'use client';

import { SmartInput } from '@web/ui';

import type { JobKind } from '@/features/jobs/types';

type JobKindFilter = 'all' | Extract<JobKind, 'project' | 'retainer'>;

type JobKindSelectFieldProps = {
  value: string;
  onChange: (value: JobKindFilter) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  error?: string;
  size?: 'small' | 'medium';
};

const JOB_KIND_OPTIONS: { value: JobKindFilter; label: string }[] = [
  { value: 'all', label: 'All types' },
  { value: 'project', label: 'Projects' },
  { value: 'retainer', label: 'Retainers' },
];

export function JobKindSelectField({
  value,
  onChange,
  label = 'Job Type',
  name = 'job-kind',
  disabled = false,
  error,
  size = 'small',
}: JobKindSelectFieldProps) {
  return (
    <SmartInput
      type="select"
      name={name}
      label={label}
      size={size}
      value={value || 'all'}
      options={JOB_KIND_OPTIONS}
      readOnly={disabled}
      error={error}
      onChange={(nextValue) => onChange(nextValue as JobKindFilter)}
    />
  );
}
